var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"template-edit"},[_c('app-template-editor',{attrs:{"original":_vm.originalTemplate},on:{"saved":_vm.onSaved},model:{value:(_vm.template),callback:function ($$v) {_vm.template=$$v},expression:"template"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }